export default __webpack_public_path__ + "static/media/2487.e7d0c26d.png";